<template>
  <div>
    <five-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </five-header>
    <div v-html="fiveData"></div>
    <five-footer :bottom="bottom" :bottomInfo="bottomInfo"></five-footer>
  </div>
</template>

<script>
import FiveHeader from "@/components/mobile/Header";
import FiveFooter from "@/components/mobile/Footer";
export default {
  data() {
    return {
      fiveData: "",
      topStyle: "",
      actIndex: 2,
      noLine: true,
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      about: {},
      culture: {},
      developList: [],
      teamList: [],
      partner: [],
      titleObj: {
        title: "5G彩信",
        desc: "实时互动，双向链接，企业与客户的联络者\n链起您与用户的沟通桥梁，做就做说一不二的精准营销",
      },
    };
  },
  components: {
    FiveHeader,
    FiveFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getFiveData();
    this.getPageData();
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_fiveG");
      } else {
        this.$router.push("/five_g");
      }
    },
    getFiveData() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productdetail",
        { id: 3 },
        (res) => {
          if (res.code == 1) {
            this.fiveData = res.data.content;
          }
        }
      );
    },
    getPageData() {
      this.$http.post("home/index/m_aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;

        this.topStyle =
          "background-image:url('" +
          require("../../static/images/fiveG/m_bg.png") +
          "')";

        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/mobile/FiveG.vue